/**
 * New Algorithm Route
 * Create a new trading algorithm
 */

import { createFileRoute, useNavigate, Link } from '@tanstack/react-router'
import { useAppStore } from '@/lib/store'
import { AlgorithmForm } from '@/components/algorithms/algorithm-form'
import { ArrowLeft } from 'lucide-react'
import { Button } from '@/components/ui/button'

export const Route = createFileRoute('/dashboard/algorithms/new')({
  component: NewAlgorithm,
})

function NewAlgorithm() {
  const navigate = useNavigate()
  const { actions } = useAppStore()

  const handleSave = (algorithm: any) => {
    const newAlgorithm = {
      ...algorithm,
      id: Date.now().toString(),
      createdAt: new Date().toISOString(),
      performance: {
        totalReturn: 0,
        totalReturnPercent: 0,
        winRate: 0,
        profitFactor: 0,
        sharpeRatio: 0,
        maxDrawdown: 0,
        totalTrades: 0,
        avgWin: 0,
        avgLoss: 0,
      },
    }
    actions.addAlgorithm(newAlgorithm)
    navigate({ to: '/dashboard/algorithms/$id', params: { id: newAlgorithm.id } })
  }

  const handleCancel = () => {
    navigate({ to: '/dashboard/algorithms' })
  }

  return (
    <div className="p-8 space-y-6">
      {/* Header */}
      <div className="flex items-center gap-4">
        <Link to="/dashboard/algorithms">
          <Button variant="ghost" size="sm">
            <ArrowLeft className="h-4 w-4 mr-2" />
            Back to Algorithms
          </Button>
        </Link>
        <div>
          <h1 className="text-2xl font-bold">Create New Algorithm</h1>
          <p className="text-muted-foreground">Configure your trading algorithm parameters</p>
        </div>
      </div>

      <AlgorithmForm onSave={handleSave} onCancel={handleCancel} />
    </div>
  )
}
